export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/TimerWorker.30312e79.worker.js");
}
